import React from "react";

import { GetRoleName, Role as UserRole } from "../models/Role";

function Role({ role }: { role: UserRole | undefined }) {
  return <>{GetRoleName(role)}</>;
}

export default Role;
